export default { sha: '06aabdbbf29ae61c7bc78baec465839ba067a4fa', buildNumber: 'undefined' }
